<vdr-datetime-picker
    [formControl]="formControl"
    [min]="config?.min"
    [max]="config?.max"
    [yearRange]="config?.yearRange"
    [readonly]="readonly"
>
</vdr-datetime-picker>
